import { useEffect } from 'react';

export const MobileRedirectHandler = () => {
    useEffect(() => {
        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        if (isMobile) {
            // Формируем ссылку для открытия в нативном приложении
            const deepLink = `plonline://pl-online.ru/mobile${window.location.search}`;

            // Пытаемся открыть приложение
            window.location.replace(deepLink);

            // Резервный таймер: если приложение не открылось за 2 сек, показываем инструкцию
            const timer = setTimeout(() => {
                const manualOpen = confirm("Открыть приложение pl-online?");
                if (manualOpen) window.location.href = deepLink;
            }, 2500);

            return () => clearTimeout(timer);
        }
    }, []);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-white p-6 text-center">
            <h2 className="text-2xl font-bold mb-4">Вход в мобильное приложение</h2>
            <p className="text-gray-600 mb-8">
                Мы пытаемся перенаправить вас в установленное приложение **pl-online**.
            </p>
            <a
                href={`plonline://pl-online.ru/mobile${window.location.search}`}
                className="bg-blue-600 text-white px-8 py-3 rounded-xl font-bold hover:bg-blue-700 transition"
            >
                Открыть приложение вручную
            </a>
            <p className="mt-8 text-sm text-gray-400">
                Если приложение не установлено, установите его по ссылке от администратора.
            </p>
        </div>
    );
};
